import domready from 'domready';

domready(() => {    
    const WIDGET_VISIBLE_CLASS = 'widget-container-block__widget--visible';
    const TOGGLE_OPTION_SELECTED_CLASS = 'widget-container-block__toggle-option--selected';

    const dataWidgetContainerEls = document.querySelectorAll('[data-widget-container]');
    
    /**
     * Initialize widget containers
     */
    [].forEach.call(dataWidgetContainerEls, (dataWidgetContainerEl) => {
        const buttonEls = dataWidgetContainerEl.querySelectorAll('[data-toggle-widget]');
        const selectedButtonEl = dataWidgetContainerEl.querySelector(`.${TOGGLE_OPTION_SELECTED_CLASS}`) || buttonEls[0];

        [].forEach.call(buttonEls, (el) => {
            el.addEventListener('click', () => {
                activateWidget(dataWidgetContainerEl, el);
            });

            el.addEventListener('keydown', (e) => {
                handleKeydown(e, dataWidgetContainerEl, el);
            });
        });

        [].forEach.call(buttonEls, (buttonEl) => {
            hideWidget(dataWidgetContainerEl, buttonEl);
        });

        selectedButtonEl && showWidget(dataWidgetContainerEl, selectedButtonEl);
    });

    /**
     * Activate widget
     */
    function activateWidget(dataWidgetContainerEl, buttonEl) {
        const allButtonsEls = dataWidgetContainerEl.querySelectorAll('[data-toggle-widget]');

        [].forEach.call(allButtonsEls, (currentButtonEl) => {
            hideWidget(dataWidgetContainerEl, currentButtonEl);
        });

        showWidget(dataWidgetContainerEl, buttonEl);
    }

    /**
     * Hide widget
     */
    function hideWidget(dataWidgetContainerEl, buttonEl) {
        buttonEl.classList.remove(TOGGLE_OPTION_SELECTED_CLASS);

        buttonEl.setAttribute('aria-selected', 'false');
        buttonEl.setAttribute('tabindex', '-1');

        const widgetId = buttonEl.dataset.toggleWidget;

        const widgetEl = dataWidgetContainerEl.querySelector(`[data-widget="${widgetId}"]`);

        if(!widgetEl) {
            return;
        }

        widgetEl.classList.remove(WIDGET_VISIBLE_CLASS);

        widgetEl.setAttribute('aria-hidden', 'true');
    }

    /**
     * Show widget
     */
    function showWidget(dataWidgetContainerEl, buttonEl) {
        buttonEl.classList.add(TOGGLE_OPTION_SELECTED_CLASS);

        buttonEl.setAttribute('aria-selected', 'true');
        buttonEl.setAttribute('tabindex', '0');

        const widgetId = buttonEl.dataset.toggleWidget;

        const widgetEl = dataWidgetContainerEl.querySelector(`[data-widget="${widgetId}"]`);

        if(!widgetEl) {
            return;
        }

        widgetEl.classList.add(WIDGET_VISIBLE_CLASS);

        widgetEl.setAttribute('aria-hidden', 'false');
    }

    /**
     * Handle tab keyboard navigation
     */
    function handleKeydown(event, dataWidgetContainerEl, buttonEl) {
        const buttonEls = [].slice.call(dataWidgetContainerEl.querySelectorAll('[data-toggle-widget]'));
        const currentIndex = buttonEls.indexOf(buttonEl);
        let nextIndex = currentIndex;

        switch(event.key) {
            case 'ArrowLeft':
            case 'ArrowUp':
                nextIndex = currentIndex === 0 ? buttonEls.length - 1 : currentIndex - 1;
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                nextIndex = currentIndex === buttonEls.length - 1 ? 0 : currentIndex + 1;
                break;
            case 'Home':
                nextIndex = 0;
                break;
            case 'End':
                nextIndex = buttonEls.length - 1;
                break;
            default:
                return;
        }

        event.preventDefault();

        const nextButtonEl = buttonEls[nextIndex];

        if(!nextButtonEl) {
            return;
        }

        nextButtonEl.focus();
        activateWidget(dataWidgetContainerEl, nextButtonEl);
    }
});
